module.exports = __webpack_public_path__ + "img/img_2.c8ba0aea.png";